<script>
import { mapState } from 'vuex';
import {
  DOCUMENT_FORMAT_HTML,
  DOCUMENT_FORMAT_SCAN
} from '@src/api/entities/ApiDocumentSearchCard';
import DocumentRoute from '@@/document/mixins/DocumentRoute';

export default {
  mixins: [DocumentRoute],

  props: {
    /** @type {Object|ApiDocumentSearchCardDef} */
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(['databases', 'documentStatuses']),

    /** @returns {ApiDatabase|undefined} */
    database() {
      return this.databases[this.item.dbId];
    },

    dbName() {
      return this.database ? this.database.name : '';
    },

    dbIconStyle() {
      return this.database
        ? {
            backgroundImage: `url('${this.database.iconUrl}')`
          }
        : '';
    },

    amendment() {
      let orgName = this.item.organization,
        approvalDate = this.item.approvalDate || '';

      if (approvalDate) {
        approvalDate = approvalDate
          .split('-')
          .reverse()
          .join('.');
      }
      return orgName + (orgName && approvalDate ? ', ' : '') + approvalDate;
    },

    statusIcon() {
      return this.documentStatuses[this.item.statusId].icon;
    },

    documentRoute() {
      return this.makeDocumentRoute(this.item.id);
    },

    documentHtmlRoute() {
      return this.item.format.includes(DOCUMENT_FORMAT_HTML)
        ? this.documentRoute
        : null;
    },

    documentScanRoute() {
      return this.item.format.includes(DOCUMENT_FORMAT_SCAN)
        ? this.makeDocumentScanRoute(this.item.id)
        : null;
    }
  },

  methods: {
    onButtonFavoriteClick() {
      this.$emit('favorite-click', this.item.id, this.item.isFavorite);
    },

    onButtonWatchedClick() {
      this.$emit('watched-click', this.item.id, this.item.isWatched);
    }
  }
};
</script>
